export default "__VITE_ASSET__DLVpkUNv__"